module.exports = __webpack_public_path__ + "static/img/chenlong.0f56609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/chenlong.jpg
// module id = dzoF
// module chunks = 0